export const UnixToDateFull = function (unixtime, tz) {
    if (unixtime===0) {return '';}
    let dt = new Date((unixtime + tz * 3600) * 1000).toISOString();
    return dt.substr(0, 10) + " " + dt.substr(11, 8)
};

export const UnixToDateYMD = function (unixtime, tz) {
    if (unixtime===0) {return '';}
    return new Date((unixtime + tz * 3600) * 1000).toISOString().substr(0, 10)
};

export const DefaultDate = function (dayDiff) {
    let diff = dayDiff || 0;
    let dateNow = new Date();
    dateNow.setDate(dateNow.getDate() + diff)
    return dateNow.toISOString().substr(0, 10);
}